<template>
  <!-- 上传个数限制
       @author: 王汝鹏
       @date: 2019-9-15
   -->
  <div class="setting-item">
    <el-form-item label="上传个数限制"> 
      <el-input-number v-model="uploadLimit"
                        placeholder="请输入最大上传个数" 
                       :min="1" >
      </el-input-number>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 上传个数限制
     *  @description 将 limit 字段映射到当前 uploadLimit 计算属性
     *  @return {String}
     *  @author 王汝鹏
     *  @version 2019-09-16
     */
    ...mapComputed({ 
      uploadLimit: { 
        parent: i => i.baseOption,
        attr: "limit" 
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingUploadLimit.vue